/**
 * Kontener dla portali (createPortal).
 * Renderujemy do `.app`, a nie do `body`, żeby portale dziedziczyły zmienne instancji
 * (np. --primary-color, --secondary-font) ustawiane na `.app.--<type>`.
 */
export const getPortalRoot = (): HTMLElement =>
  document.querySelector<HTMLElement>('.app') || document.body
